var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHubspotIntRectangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#fff",
    stroke: "#dce1e9",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.111,15.085v-3.97A3.057,3.057,0,0,0,35.874,8.36V8.269a3.057,3.057,0,0,0-3.057-3.057h-.091a3.057,3.057,0,0,0-3.057,3.057V8.36a3.057,3.057,0,0,0,1.763,2.755v3.97A8.657,8.657,0,0,0,27.315,16.9L16.428,8.418A3.437,3.437,0,1,0,13.1,11a3.407,3.407,0,0,0,1.7-.461l10.721,8.342a8.684,8.684,0,0,0,.133,9.781l-3.261,3.262A2.883,2.883,0,1,0,24.274,33.8L27.5,30.577a8.7,8.7,0,1,0,6.611-15.492M32.774,28.142a4.464,4.464,0,1,1,4.307-4.464,4.463,4.463,0,0,1-4.307,4.464",
    transform: "translate(-1.583 5.223)",
    fill: "#ff7a59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubspotIntRectangleIcon);
export default __webpack_public_path__ + "static/media/hubspot-int-rectangle-icon.0b5e6c1ef8e2f536a19d8996a381c5db.svg";
export { ForwardRef as ReactComponent };